import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const SIGN_OUT_MUTATION = gql`
  mutation SignOut {
    signOut {
      success
    }
  }
`;

export function useSignOut() {
  const [signOutMutation, { loading }] = useMutation(SIGN_OUT_MUTATION);

  const signOut = async () => {
    await signOutMutation();
  };

  return { signOut, loading };
}
